export async function CheckCacheResources(resources:string[],appVersion: string){
    caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          // Open each cache
          if(cacheName.includes("adp") && cacheName.includes("appVersion")){
          caches.open(cacheName).then(cache => {
            // Retrieve all cached requests
            cache.keys().then(cachedRequests => {
              cachedRequests.forEach(request => {
                console.log(`Cache: ${cacheName} - Cached resource: ${request.url}`);
              });
            });
          });   
        }
        else {
            console.warn("No expected ADP cache found", {resources}, {appVersion});
        }
        });
      }).catch(error => {
        console.error('Error accessing caches:', error);
      });
}